import { render, staticRenderFns } from "./DataHeading.vue?vue&type=template&id=b7a2807c"
import script from "./DataHeading.vue?vue&type=script&lang=js"
export * from "./DataHeading.vue?vue&type=script&lang=js"
import style0 from "./DataHeading.vue?vue&type=style&index=0&id=b7a2807c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports